var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoucher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "02.Atoms/02.Icons/01.Basic/Solid/Payment") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "02.Atoms/02.Icons/01.Basic/Solid/Payment",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,7 L23,18 C23,19.1 22.1,20 21,20 L4,20 L4,18 L21,18 L21,7 L23,7 Z M17,4 C18.1,4 19,4.9 19,6 L19,14 C19,15.1 18.1,16 17,16 L3,16 C1.9,16 1,15.1 1,14 L1,6 C1,4.9 1.9,4 3,4 L17,4 Z M10,7 C8.34,7 7,8.34 7,10 C7,11.66 8.34,13 10,13 C11.66,13 13,11.66 13,10 C13,8.34 11.66,7 10,7 Z",
    id: "Combined-Shape",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucher);
export default __webpack_public_path__ + "static/media/Voucher.37ea6dd9aef159316e7e21f7e58bd745.svg";
export { ForwardRef as ReactComponent };